import React from "react";
var __jsx = React.createElement;
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import Layout from "@/_LayoutsRelated/layout/Layout";
var SellTradeLayout = function SellTradeLayout(_ref) {
  var children = _ref.children;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: !!isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-trade-layout-mobile",
    className: "bg-blue-alice overflow-hidden overscroll-none "
  }, children)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("style", null, "\n                            .my-scroll::-webkit-scrollbar { width: 4px; }\n                            .my-scroll::-webkit-scrollbar-track { background: #E6E6E6; }\n                            .my-scroll::-webkit-scrollbar-thumb { background-color: #0D0DB5; border-radius: 100px; }\n                       "), /*#__PURE__*/React.createElement(Layout, {
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-trade-layout-desktop",
    className: ""
  }, children)))));
};
export default SellTradeLayout;